export const HERO_BG =
  "https://images.pexels.com/photos/20804731/pexels-photo-20804731.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1600";

export const FOUNDER_IMG =
  "https://static.prod-images.emergentagent.com/jobs/02210e6d-97ca-4a9a-87c2-ebe863f340b9/images/3c20d0e86abeff21efd77721e7bda0e4e78b2ba29d5b5d62f28cfdeab3c39b24.jpeg";

export const TESTIMONIAL_IMG =
  "https://images.unsplash.com/photo-1752159646124-27b7f6973be8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export const MANIFESTO = [
  { n: "01", title: "Vulnerability is not weakness.", body: "It is the most accurate measure of courage. We create the conditions where leaders can lower the armour they wear to work." },
  { n: "02", title: "Trust is built in small moments.", body: "Not in offsites or slogans, but in the willingness to be seen. We design deliberate moments of honesty that compound over time." },
  { n: "03", title: "Connection outperforms control.", body: "Teams that feel safe take smarter risks, surface hard truths sooner, and stay. Belonging is a performance strategy, not a perk." },
  { n: "04", title: "Authenticity scales.", body: "When leaders go first, permission ripples outward. We equip organisations to make honesty a habit, not a one-off event." },
];

export const WORKSHOPS = [
  {
    num: "W/01",
    title: "The Corporate Mask We Wear",
    duration: "All employees · 8–30 people · 3 hours",
    body: "An opportunity to be real and align your personal self with your work self. A facilitated experience of sharing openly and honestly by letting our masks down — speaking about the things that affect us, both outside and inside of work.",
    suited: "All employees.",
    image: "https://images.pexels.com/photos/5710984/pexels-photo-5710984.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  },
  {
    num: "W/02",
    title: "Relationships and Trust",
    duration: "8–30 people · 3 hours",
    body: "Strong teams are built on trust, not just roles. A facilitated workshop on the quality of relationships inside and outside of work.",
    suited: "Teams experiencing growth, change, disconnection or communication challenges.",
    image: "https://images.unsplash.com/photo-1694158143801-1f21643a0b61?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    num: "W/03",
    title: "Authentic Leadership",
    duration: "Executives · Intimate group · Mentorship lens",
    body: "Leadership isn't about having all the answers — it's about creating the conditions for people to speak authentically and to be themselves. A leadership experience exploring authenticity, vulnerability towards colleagues, trust and the human side of leadership.",
    suited: "Executives, senior leaders and emerging leadership teams.",
    image: "https://images.pexels.com/photos/1198171/pexels-photo-1198171.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  },
];

export const TESTIMONIALS = [];

export const STATS = [
  { k: "12k+", v: "Leaders in the room" },
  { k: "94%", v: "Would recommend" },
  { k: "60+", v: "Organisations" },
  { k: "8yrs", v: "Facilitating trust" },
];
